module.exports = __webpack_public_path__ + "img/oltasok_goreny.5e7acb89.jpg";